import { extendServiceContainer } from '@iotize/tap';
import { VariableService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    variable: VariableService;
  }
}

export const _TAP_SERVICE_EXTENSION_VARIABLE_ = extendServiceContainer(
  'variable',
  VariableService,
);
